import Joi from 'joi-full';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose, withHandlers } from 'recompose';

import { TOP_UP_CARD } from '../constants';
import TopUpModal from '../components/TopUpModal';
import { updateGiftCard } from '../../order/actions';
import withToggle from '../../../common/hoc/withToggle';
import { syncValidateData } from '../../../common/validator';
import withNotifications from '../../../common/withNotifications';

const schema = Joi.object().keys({
  amount: Joi.number()
    .min(1)
    .required(),
});

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: TOP_UP_CARD,
  validate,
});

const TopUpModalContainer = compose(
  connect(
    null,
    { charge: updateGiftCard },
  ),
  withNotifications,
  withHandlers({
    onSubmit: props => (data) => {
      const payload = { ...data, ...props.giftCard };
      props.charge(payload);
    },
  }),
  form,
  withToggle('modal', false),
)(TopUpModal);

export default TopUpModalContainer;
